import { useNavigate } from "react-router-dom";

export default function UnauthenticatedProfile() {

    const navigate = useNavigate();

    const handleLogin = (event) => {
        event.preventDefault();
        navigate("/login")
    };

    return (
        <div id="profile-menu"
            className="absolute right-0 mt-2 w-auto min-w-[150px] max-w-[300px] border border-gray-300 bg-gray-300 rounded shadow-lg overflow-hidden"
            style={{ zIndex: 9999 }} // Ensure it is on top
        >

            {/* Reset Password Section */}
            {/* <div className="p-4">
                <button
                    onClick={handleForgetPassword}
                    className="text-indigo-700 hover:underline font-medium text-left"
                >
                    Forget Password
                </button>
            </div> */}

            {/* Logout Section */}
            <div className="p-4">
                <button
                    onClick={handleLogin}
                    className="text-indigo-700 hover:underline font-medium"
                >
                    LOGIN
                </button>
            </div>
        </div>
    );

}